export enum VehicleAdministratorRole {
    OWNER = '1001',
    SUPERVISOR = '1002',
    DRIVER = '1003'
  }